export default __webpack_public_path__ + "static/media/contornoLogo.f3fbe035.svg";